import { Space, Select } from 'antd';
import React, { FC } from 'react';
import { DashboardCard } from '@/presentation/components/dashboard-card';

export interface DashboardHeaderProps {
  onChange?: (deviceType: DeviceType) => void;
}

export enum DeviceType {
  All = '',
  Simulator = 'simulator',
  Device = 'device'
}


export const DEVICE_TYPE_OPTIONS = [
  { label: '真机+模拟器', value: DeviceType.All },
  { label: '真机', value: DeviceType.Device },
  { label: '模拟器', value: DeviceType.Simulator },
];

export const DashboardHeader: FC<DashboardHeaderProps> = (props) => {
  const {} = props;

  return (
    <DashboardCard title={''}>
      <Space className={'reset-form'}>
        <Space direction={'vertical'}>
          <span style={{ fontSize: 12 }}>设备类型</span>
          <Select
            options={DEVICE_TYPE_OPTIONS}
            style={{ width: 208 }}
            defaultValue={DeviceType.All}
            onChange={props.onChange}
          />
        </Space>
      </Space>
    </DashboardCard>
  );
};
